module.exports = __webpack_public_path__ + "img/Bajaj Logo.844b4d0a.png";